<template>
    <e-select-dialog class="e-dealer-select" :options="optionList" v-model="inputVal" :multiple="multiple" :multiple-display="multipleDisplay" item-name="accounts|comptes" :placeholder="placeholder" :dropdown-icon="dropdownIcon"
                     :allow-empty="allowEmpty" :search-keys="[`dealerid`, `alias`, `company_name`, `phone`, `email`]" :auto-height="selectionDetails"
                    track-by="dealerid" label="dealerid" title="Select account|Choisir un compte">
<!--        <template #filters v-if="canAdminEyeInWireless()">-->
<!--            <div class="p-2">-->
<!--                <b-select v-model="filters.status">-->
<!--                    <option value="all" v-tr>Actives/Inactives|Actifs/Inactifs</option>-->
<!--                    <option value="active" v-tr>Actives Only|Actifs seulement</option>-->
<!--                    <option value="inactive" v-tr>Inactives Only|Inactifs seulement</option>-->
<!--                </b-select>-->
<!--            </div>-->
<!--        </template>-->
        <template v-slot="{option}">
            <div class="company-name f-10 f-400 text-uppercase">
<!--                <span v-if="dealerParent(option.dealerid) !== option.dealerid">{{option.dealerid|dealerParent|dealer}} - </span>-->
                {{option.company_name}}
            </div>
            <span class="dealerid f-500">{{option.dealerid}}</span><template v-if="option.alias"> [{{option.alias}}]</template>
        </template>

        <template v-if="selectionDetails && !multiple && dealerSelected" #selection>
            <div class="company-name f-10 f-400 text-uppercase">
                <!--                <span v-if="dealerParent(option.dealerid) !== option.dealerid">{{option.dealerid|dealerParent|dealer}} - </span>-->
                {{dealerSelected.company_name}}
            </div>
            <span class="dealerid f-500">{{dealerSelected.dealerid}}</span>
            <template v-if="dealerSelected.alias"> [{{dealerSelected.alias}}]</template>
        </template>

        <template #badge="{option}">
            {{option.dealerid|dealer}}
        </template>

        <template #single-selection="{option}">
            {{option.dealerid|dealer}}
        </template>

        <template #details="{option}">
            <div>
                <span class="f-10"><i class="fas fa-phone mr-1"/>{{option.phone}} <i class="fas fa-envelope mx-1"/>{{option.email}}</span>
            </div>
        </template>
    </e-select-dialog>
</template>

<script>
import ESelectDialog from "./e-select-dialog.vue";

export default {
    name: `e-dealer-select`,
    components: {
        ESelectDialog
    },
    props: {
        value: {type: [String, Array]},
        placeholder: {type: String},
        allowEmpty: {type: Boolean, default: false},
        dropdownIcon: {type: String},
        options: {},
        selectionDetails: {type: Boolean}, // only for single selection
        multiple: {type: Boolean, default: false},
        multipleDisplay: {type: String, default: `compact`} // compact or expanded, see e-select-dialog
    },
    data() {
        return {
            filters: {
                status: `active`
            }
        }
    },
    computed: {
        inputVal: {
            get() {
                if (Array.isArray(this.value)) {
                    return this.value.map(dealerId => dealerId.toLowerCase());
                } else {
                    return this.value?.toLowerCase();
                }
            },
            set(newValue) {
                if (Array.isArray(newValue)) {
                    this.$emit(`input`, newValue.map(dealerId => dealerId.toLowerCase()));
                } else {
                    this.$emit(`input`, newValue?.toLowerCase());
                }
            }
        },
        dealerSelected() {
            if (!this.value || typeof this.value !== `string`)
                return null;

            return this.optionList.find(d => d.dealerid.toLowerCase() === this.value?.toLowerCase())
        },
        optionList() {
            let list = this.options ? this.options : this.$store.state.dealers;
            list.forEach(dealer => dealer.dealerid = dealer.dealerid.toLowerCase());
            return list;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
